<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Options</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        <div class="configurationDetailRow">
          @if (unitVoltageSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Unit Voltage:</label>
              <select class="halfWidthInputField" #unitVoltageInput
                [class.invalidConfigurationSelection]="isInvalidSelection(unitVoltageSelection.Name)"
                (change)="selectionChanged(unitVoltageSelection, unitVoltageInput.value)"
                [value]="unitVoltageSelection.Value.toString()">
                @for (allowable of unitVoltageSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="unitVoltageSelection.Value && unitVoltageSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (controlsSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Controls:</label>
              <select class="halfWidthInputField" #controlsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(controlsSelection.Name)"
                (change)="selectionChanged(controlsSelection, controlsInput.value)"
                [value]="controlsSelection.Value.toString()">
                @for (allowable of controlsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="controlsSelection.Value && controlsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (fanOptionsSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Fan:</label>
              <select class="halfWidthInputField" #fanOptionsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(fanOptionsSelection.Name)"
                (change)="selectionChanged(fanOptionsSelection, fanOptionsInput.value)"
                [value]="fanOptionsSelection.Value.toString()">
                @for (allowable of fanOptionsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="fanOptionsSelection.Value && fanOptionsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (pumpOptionsSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Pump:</label>
              <select class="halfWidthInputField" #pumpOptionsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(pumpOptionsSelection.Name)"
                (change)="selectionChanged(pumpOptionsSelection, pumpOptionsInput.value)"
                [value]="pumpOptionsSelection.Value.toString()">
                @for (allowable of pumpOptionsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="pumpOptionsSelection.Value && pumpOptionsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (heatExchangerOptionsSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Heat Exchanger Options:</label>
              <select class="halfWidthInputField" #heatExchangerOptionsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(heatExchangerOptionsSelection.Name)"
                (change)="selectionChanged(heatExchangerOptionsSelection, heatExchangerOptionsInput.value)"
                [value]="heatExchangerOptionsSelection.Value.toString()">
                @for (allowable of heatExchangerOptionsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="heatExchangerOptionsSelection.Value && heatExchangerOptionsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
      </div>
    </div>
  }
</div>
